import React from "react";
import "../styles/Header.css";

function Header() {
  return (
    <header>
      <h1 className="title">Pokémon Memory Game</h1>
    </header>
  );
}

export default Header;
